<template>
  <div style="position:relative;overflow: hidden;">
    <div v-if="qrcode && showQrcode" class="alert-box">
      <div class="dialog-close-btn" @click="showQrcode = false">X</div>
      <img :src="qrcode" class="lv-img" />
      <div class="text-box">
        <p>1、可以扫码将职位介绍发送给别人；</p>
        <p>2、阿尔法内部顾问看到的是完整版信息；</p>
        <p>3、候选人将看到脱敏版本；</p>
      </div>
    </div>
    <table class="a-table a-table-head" cellspacing="0" :style="{ width: tableWidth, left: tableHeadLeft }">
      <tr>
        <th style="width:55px"></th>
        <th v-if="checkable" style="width:30px">
          <input v-model="isCheckedAll" type="checkbox" @change="onCheckAll" />
        </th>
        <template v-for="head in tableHeads">
          <th v-if="!head.hidden" :key="head.label + 'h'" :style="{ width: head.width + 'px' || '100px' }">
            {{ head.label }}
          </th>
        </template>
      </tr>
    </table>

    <div ref="scroller" :style="layoutStyle" class="a-table-layout" @scroll="onScroll">
      <table
        v-if="ready"
        class="a-table a-table-body"
        cellspacing="0"
        :style="{ width: tableWidth, marginBottom: tableBottom + 'px' }"
      >
        <tr style="height:0">
          <th style="width:55px"></th>
          <th v-if="checkable" style="width:30px"></th>
          <template v-for="head in tableHeads">
            <th v-if="!head.hidden" :key="head.label" :style="{ width: head.width ? head.width + 'px' : '100px' }"></th>
          </template>
        </tr>
        <tr
          v-for="(item, index) in hasLv"
          :key="'hasLv' + 'item' + start + index"
          :class="{ 'a-table-row-highlight': item.highlight }"
          :style="trStyle(item)"
        >
          <td style="text-align:center">{{ start + index + 1 }}</td>
          <td style="text-align:center">
            <input v-model="hasLv[index].checkedRow" type="checkbox" @change="onCheckOne(index)" />
          </td>
          <template v-for="head in tableHeads">
            <a-td
              v-if="!head.hidden"
              :key="head.label + start + index + 'b'"
              :head="head"
              :item="item"
              :index="index"
            ></a-td>
          </template>
        </tr>
      </table>
    </div>
    <FeedbackDialog ref="FeedbackDialog" :project="project" @computedLvBadge="computedLvBadge"></FeedbackDialog>
  </div>
</template>
<script>
import aTd from './a-td'
import tableHeads from './radish-list-table-heads'
import FeedbackDialog from './FeedbackDialog'

export default {
  components: { aTd, FeedbackDialog },
  mixins: [tableHeads],
  props: {
    pid: {
      type: String,
    },
    project: {
      type: Object,
      default: () => ({}),
    },
    data: {
      type: Array,
      default: () => [],
    },
    checkable: {
      type: Boolean,
      default: true,
    },
    height: {
      type: Number,
      default: 600,
    },
    activeRowId: {
      type: String,
    },
    start: {
      type: Number,
      default: 0,
    },
    onClickSetting: {
      type: Function,
      default: function() {},
    },
  },
  data: function() {
    return {
      ready: false,
      tableData: [],
      // displayData: [],
      isCheckedAll: false,
      tableHeadLeft: 0,
      shiftKeyPressed: false,
      lastCheckIndex: '',
      qrcode: '',
      showQrcode: true,
    }
  },
  computed: {
    hasLv() {
      return this.tableData.filter(v => v.lvObj)
    },
    lvHasSend() {
      return this.tableData.filter(v => v.lvObj && Array.isArray(v.lvObj.sendRecord) && v.lvObj.sendRecord.length > 0)
    },
    tableWidth: function() {
      let width = 60
      if (!this.checkable) {
        width = 30
      }
      this.tableHeads.forEach(h => {
        if (!h.hidden) {
          h.width = h.width || 100
          width += h.width
        }
      })
      return `${width}px`
    },
    tableBottom: function() {
      return 0
      // return (this.lvHasSend.length - this.displayData.length) * 30
    },
    layoutStyle: function() {
      if (this.height) {
        return { height: `${parseInt(this.height) + 70}px` }
      } else return {}
    },
  },
  watch: {
    data(newValue, oldValue) {
      this.setDisplay(true)
    },
    project: {
      handler(newValue, oldValue) {
        if (newValue && newValue._id && newValue._id !== (oldValue && oldValue._id)) {
          this.getQrCode()
        }
      },
      immediate: true,
    },
  },
  created() {
    this.shiftKeyDown = e => {
      if (e.key === 'Shift') {
        return (this.shiftKeyPressed = true)
      }
    }
    this.shiftKeyUp = e => {
      if (e.key === 'Shift') {
        return (this.shiftKeyPressed = false)
      }
    }
    document.addEventListener('keydown', this.shiftKeyDown)
    return document.addEventListener('keyup', this.shiftKeyUp)
  },
  destroyed() {
    document.removeEventListener('keydown', this.shiftKeyDown)
    return document.removeEventListener('keyup', this.shiftKeyUp)
  },
  methods: {
    computedLvBadge() {
      this.$emit('computedLvBadge')
    },
    showFeedback(curRad) {
      this.$refs.FeedbackDialog.open(this.hasLv, curRad)
    },
    showAction(curRad) {
      this.onClickSetting(curRad)
    },
    async getQrCode() {
      const account = app.user.account
      const url = `https://www.yuanshouhr.com/api/salaryNew/getProjectMpCode?hunterId=${account}&id=${this.project._id}`
      const res = await window.app.service('misc').urlGet({ url })
      const lvRes = res.data
      if (lvRes.status === 'success') {
        this.qrcode = lvRes.data && lvRes.data.code
        // this.qrcode = img
      }
    },
    clickName: async function(item) {
      this.currentRow = item
      await app.service('project').saveRecords({
        pid: this.project._id,
        项目名称: this.project && this.project.项目名称,
        rid: item._id,
        姓名: item.姓名,
        type: '查看人选',
      })
      window.open(`${window.frontend}/#/radish-detail-blank/${item.rid}?p=${this.pid}`, '_blank')
    },
    getSimi: async function(item) {
      const res = await app.service('radish').simpleFetch({ _id: item.rid })
      if (res.status === 'fail') {
        this.$message.error(res.msg)
        return
      } else if (res.msg === 'nothave') {
        this.$message.warning('人选不存在')
        this.loadData()
        return
      }
      item._id = item.rid
      if (item.status && item.status > 0) {
        app.root.$refs.simiDialog.show(item)
      }
    },
    clickCompany: function(companyName) {
      app.root.onPull()
      app.root.$refs.drawer.search({
        type: '公司',
        keywords: companyName,
      })
    },
    getPhone: async function(id) {
      const res = await app.service('radish').simpleFetch({ _id: id, fields: { 手机: 1 } })
      if (res.status === 'success') {
        const radish = this.tableData.filter(r => r._id === id)
        await app.service('project').saveRecords({
          pid: this.project._id,
          项目名称: this.project && this.project.项目名称,
          rid: id,
          姓名: radish.姓名,
          type: '查看手机',
        })
        this.tableData.forEach(rad => {
          if (rad.rid === id) {
            rad.手机 = res.data.手机
          }
        })
      }
    },
    trStyle: function(item) {
      const style = {}
      if (this.activeRowId == item._id) {
        style.backgroundColor = '#eef1f6'
      } else if (item['置顶']) {
        style.backgroundColor = '#ecf5ff'
      }
      // else if (!(localStorage.yxColorOff === 'true')) {
      //   if (item['意向'] == 'Y') {
      //     style.backgroundColor = '#ffe5e5'
      //   } else if (item['意向'] == 'N') {
      //     style.backgroundColor = '#ffffe1'
      //   } else if (item['意向'] == 'F') {
      //     style.backgroundColor = '#e5e5ff'
      //   }
      // }
      return style
    },
    onCheckAll: function() {
      this.tableData = this.tableData.map(dt => {
        dt.checkedRow = this.isCheckedAll
        return dt
      })
    },
    onCheckOne: function(index) {
      if (this.lastCheckIndex !== '') {
        if (
          this.shiftKeyPressed &&
          this.tableData[index].checkedRow == this.tableData[this.lastCheckIndex].checkedRow
        ) {
          const big = Math.max(this.lastCheckIndex, index)
          const small = Math.min(this.lastCheckIndex, index)
          this.tableData = this.tableData.map((dt, i) => {
            if (i >= small && i <= big) {
              dt.checkedRow = this.tableData[index].checkedRow
            }
            return dt
          })
        }
      }
      this.lastCheckIndex = index
    },
    getChecked: function() {
      return this.tableData.filter(dt => dt.checkedRow)
    },
    cancelChecked() {
      this.tableData.forEach(dt => {
        this.$set(dt, 'checkedRow', false)
      })
    },
    onScroll: function() {
      this.tableHeadLeft = `${-this.$refs.scroller.scrollLeft}px`
    },
    setDisplay: function(force) {
      if (force) {
        this.ready = false
        this.tableData = this.data
        this.isCheckedAll = false
        this.ready = true
      }
      // this.getLogs()
    },
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    // async getLogs(){
    //   const pid = this.pid||this.project._id
    //   if(!pid) {
    //     await this.delay(100)
    //     return this.getLogs()
    //   }
    //   const arr = this.tableData.filter(v=>v.lvObj)
    //   const account = app.user.account
    //   for(const obj of arr){
    //     const tel = obj.lvObj.phoneNumber
    //     const url = `https://www.yuanshouhr.com/api/deliver/getCommunication?coreProjectId=${pid}&phoneNumber=${tel}&hunterId=${account}&identity=hunter`
    //     const res = await window.app.service('misc').urlGet({ url })
    //     if (res.status === 'success') {
    //       const logs = Array.isArray(res.data)?res.data:[]
    //       logs.sort((a,b)=>b.time - a.time)
    //       this.$set(obj,'progressLogs',logs)
    //       this.$set(obj,'最新操作时间',logs[0]&&logs[0].time)
    //     }else this.$message.error(res.msg)
    //   }
    // },
    showCellsDialog: function() {
      const tableHeads = this.tableHeads.map(head => ({ label: head.label, hidden: head.hidden || false }))
      this.$refs.cellsDialog.show(tableHeads)
    },
    // reset: function() {
    //   this.ready = false
    //   this.isCheckedAll = false
    //   this.tableData = this.data
    //   this.displayData = this.tableData.slice(0, 50)
    //   this.ready = true
    //   this.$refs.scroller.scrollTop = 0
    // },
    getTableData() {
      return this.tableData
    },
  },
}
</script>
<style scoped>
.a-table {
  table-layout: fixed;
  border-left: 1px solid #eee;
  border-bottom: 1px solid #eee;
  color: #444;
}
.a-table-head {
  position: relative;
}
.a-table-layout {
  position: relative;
  width: 100%;
  overflow: auto;
}
.a-table > tr > th {
  border-top: 1px solid #eee;
  border-right: 1px solid #eee;
  box-sizing: border-box;
}
.a-table > tr > td {
  border-top: 1px solid #eee;
  border-right: 1px solid #eee;
  box-sizing: border-box;
  height: 25px;
  position: relative;
}
/* .a-table>tr>td .el-select .el-input__suffix {
  display: none;
}
.a-table>tr>td .el-select .el-input__inner {
  padding-right: 0;
} */
.a-table > tr > td select {
  border: none;
  outline: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  text-align: center;
  text-align-last: center;
}
.a-table-body {
  position: relative;
  top: -4px;
}
.a-link {
  color: #0472c7;
  cursor: pointer;
}
.a-tag {
  background-color: rgba(64, 158, 255, 0.1);
  display: inline-block;
  padding: 0 5px;
  color: #0472c7;
  border-radius: 4px;
  box-sizing: border-box;
  border: 1px solid rgba(64, 158, 255, 0.2);
  white-space: nowrap;
  line-height: 1.2;
}
.cc-icon {
  display: inline-block;
  height: 14px;
  width: 14px;
  font-size: 12px;
  text-align: center;
  border-radius: 7px;
  line-height: 1;
  color: #fff;
}
.cc-icon-g {
  background-color: #ccc;
}
.cc-icon-r {
  background-color: #ffb5b0;
}
.cc-icon-y {
  background-color: #f8df9c;
}
.simi-icon {
  position: absolute;
  left: 0;
  top: 0;
  display: inline-block;
  height: 14px;
  width: 12px;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
}
.icon-lightred {
  color: #f99;
}
.icon-red {
  color: #f66;
}
.icon-blue {
  color: #48a8ff;
}
.icon-grey {
  color: #ccc;
}
.a-table-row-highlight {
  background-color: #eef1f6;
}
.td-content {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0 5px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 25px;
  z-index: 1;
}
.a-td-select {
  opacity: 0;
}
.a-td-cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
  cursor: pointer;
}
.alert-box {
  position: absolute;
  bottom: 50px;
  right: 24px;
  width: 378px;
  display: flex;
  padding: 10px;
  background-color: #dbe8ee;
  border: 1px dashed #3d7994;
  border-radius: 4px;
  z-index: 1;
}
.lv-img {
  width: 120px;
  flex: none;
  align-self: baseline;
  margin-right: 8px;
}
.text-box {
  display: inline-flex;
  flex: auto;
  flex-direction: column;
  justify-content: space-evenly;
}
.dialog-close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
</style>
